import React from 'react'
import styled from 'styled-components'

import moment from '../../../lib/moment.js'

export const DateCell = ({ date }) => {
  const isToday = date.isSame(moment(), 'day')

  return (
    <Cell style={ { flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', borderTopColor: '#ad191f', borderTopWidth: isToday ? 5 : 0 } }>
      <div style={ { color: isToday ? '#ad191f' : 'black', marginTop: isToday ? -5 : 0 } }>{date.format('dd')}</div>
      <div style={ { color: isToday ? '#ad191f' : 'black' } }>{date.date()}</div>
    </Cell>
  )
}

const Cell = styled.div`
  border: solid #EAEAEA;
  border-width: 0px 1px 0px 0px;
`



// WEBPACK FOOTER //
// ./src/components/calendar/vertical-table/date-cell.js